/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScopeContainsServiceAccountQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ScopeContainsServiceAccountQueryOperator");
    }

    getFixupPrototypeFunction() { return ScopeContainsServiceAccountQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<ScopeContainsServiceAccountQueryOperator>): ScopeContainsServiceAccountQueryOperator {
        let obj = Object.assign(new ScopeContainsServiceAccountQueryOperator(), model);
        ScopeContainsServiceAccountQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScopeContainsServiceAccountQueryOperator>): ScopeContainsServiceAccountQueryOperator {
        if (!model) return null;
        return ScopeContainsServiceAccountQueryOperator.newInstance(<ScopeContainsServiceAccountQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScopeContainsServiceAccountQueryOperator) {
        if (!obj) return;

        models.ScopeContainsServiceAccountQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScopeContainsServiceAccountQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ScopeContainsServiceAccountQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Service account IDs to include
     */
    service_account_ids: Array<string>;

}
